import React, { useState,useEffect } from "react";

function DocumentCheckBox(props) {
    const { t } = props;

    
    const [numberOfDocument, setNumberOfDocument] = useState(1);
    const [selectedDocument, setSelectedDocument] = useState('');
    

   
    const onChangeDocumentCheckbox = (event) => {
        if (!event.target.checked)
            {
                props.item.selected =false;
                setNumberOfDocument(1);
                props.onChangeRemoveDocument(event.target.value);
            }
        
        else
        if (props.numberOfDocument< props.maxNumberOfCopy) {
            props.onChangeDocumentNumber(numberOfDocument, event.target.value,true);           
            props.item.selected =true;
            setSelectedDocument(event.target.value);
        }else
            props.item.selected =false;
    }

    const onIncreaseNumberCopy = (event) => {
      
        if (props.numberOfDocument < props.maxNumberOfCopy) {
            setNumberOfDocument(numberOfDocument + 1);
            props.onChangeDocumentNumber(numberOfDocument + 1, selectedDocument,true);
        }
    }

    const onDecreaseNumberCopy = (event) => {
        
        if (props.numberOfDocument > 1) {
            if (numberOfDocument > 1) {
                setNumberOfDocument(numberOfDocument - 1);
                props.onChangeDocumentNumber(numberOfDocument - 1, selectedDocument,false); 
            }
        }
    }

    return (
        <>
            <div class="mb-1">
                <div className="row">
                    <div className="col-8">
                        <div className="form-check">
                            <input type="checkbox" checked ={props.item.selected}  className="form-check-input" value={props.item.nameEn} onChange={onChangeDocumentCheckbox} id={props.item.code} />
                            <label className="form-check-label" htmlFor={props.item.code}>
                                {props.language === "en" ? props.item.nameEn : props.item.nameAr}
                            </label>
                        </div>
                    </div>
                    {
                    props.item.selected && (<div className="col-4" >
                        <div class="attestion-count d-inline-flex">
                            <button className="btn button-minus" type="button" onClick={onDecreaseNumberCopy}></button>
                            <input type="text" disabled={true} class="downup-input" aria-label="Small" placeholder="Copies" value={props.item.selected ? numberOfDocument : 0}  ></input>
                            <button className="btn button-plus" type="button" onClick={onIncreaseNumberCopy}></button>
                        </div>
                    </div>)
                }
                </div>
            </div>
        </>
    );

}
export default DocumentCheckBox;